import { isDragging } from './is-active.mjs';

function setDragLock(axis) {
  if (axis === "x" || axis === "y") {
    if (isDragging[axis]) {
      return null;
    } else {
      isDragging[axis] = true;
      return function () {
        isDragging[axis] = false;
      };
    }
  } else {
    if (isDragging.x || isDragging.y) {
      return null;
    } else {
      isDragging.x = isDragging.y = true;
      return function () {
        isDragging.x = isDragging.y = false;
      };
    }
  }
}

export { setDragLock };